import React from "react";

const TEST_DOMAIN = "test.americantours.com";

const SIGNUP_TEST_URL = "https://signup-test.americantours.com";
const SIGNUP_PROD_URL = "https://signup.americantours.com";

export const redirectToSignup = () => {
  if (window.location.href.indexOf(TEST_DOMAIN) !== -1) {
    window.location.replace(SIGNUP_TEST_URL);
  } else {
    window.location.replace(SIGNUP_PROD_URL);
  }
};



// WEBPACK FOOTER //
// ./src/utils/NavigationUtils.js